/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ship/frame_ship': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" _fill="none" _stroke="#FFF" stroke-miterlimit="10" d="M2.5 8.254L16 .5l13.5 7.754v15.494L16 31.5 2.5 23.748z"/><path pid="1" d="M16 32.077L2 24.038V7.964L16-.077l14 8.041v16.073l-14 8.04zM3 23.458l13 7.465 13-7.465V8.543L16 1.077 3 8.543v14.915z"/>'
  }
})
